<template>
  <div class="game-information">
    <div class="game-information-close"></div>
    <div class="tt-tabs gametab">
      <div class="index-tabs">
        <span
          v-if="tournamentsTypesLastActive"
          @click="this.tabActive = 0"
          :class="`gametab-tur ${this.tabActive === 0 ? 'active-ttab' : ''}`"
          ><span>Турнир</span></span
        >
        <span
          v-if="isAuthenticated"
          @click="this.tabActive = 1"
          :class="`gametab-fav ${this.tabActive === 1 ? 'active-ttab' : ''}`"
          ><span>Любимые</span></span
        >
        <span @click="this.tabActive = 2" :class="`gametab-win ${this.tabActive === 2 ? 'active-ttab' : ''}`"
          ><span>Выигрыши</span></span
        >
      </div>
      <div class="index-panel">
        <div v-if="tournamentsTypesLastActive && this.tabActive === 0" class="tt-panel panel-t">
          <div class="gtournament">
            <div class="gtournament-title">
              Турнир <i>{{ tournamentsTypesLastActive.title }}</i>
            </div>
            <div class="gtournament-name">
              Призовой фонд <span style="color: #fed02d">{{ tournamentsTypesLastActive.prize }}</span>
            </div>
            <img
              :src="tournamentsTypesLastActive.img"
              :alt="tournamentsTypesLastActive.title"
              class="gtournament-image"
            />

            <vue-countdown
              :time="getTime(new Date(tournamentsTypesLastActive.date_end)) - new Date().getTime()"
              :transform="transformSlotProps"
              v-slot="{ days, hours, minutes, seconds }"
            >
              <div class="gtournament-timer">
                <div class="timeTo timeTo-white" style="font-size: 18px">
                  <div class="first" v-if="days !== 0">
                    {{ days }}
                  </div>
                  <span v-if="days !== 0" style="margin-left: 5px; margin-right: 5px">дней,</span>
                  <div class="first">
                    {{ hours }}
                  </div>
                  <span>:</span>
                  <div class="first">
                    {{ minutes }}
                  </div>
                  <span>:</span>
                  <div>
                    {{ seconds }}
                  </div>
                </div>
              </div>
            </vue-countdown>

            <router-link
              :to="{ name: 'tournament', params: { slug: tournamentsTypesLastActive.slug } }"
              class="gtournament-btn"
            >
              Подробнее
            </router-link>

            <div class="gtournament-table-wrap">
              <table class="gtournament-table">
                <thead>
                  <tr>
                    <td>№</td>
                    <td>Логин</td>
                    <td>Приз</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(winner, index) in tournamentsTypesLastActive?.winners" :key="winner.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ winner.username }}</td>
                    <td>
                      <div class="tournaments-table-win-line-money" v-if="winner?.prize?.type === 'money'">
                        {{ winner?.prize?.prize }}
                      </div>
                      <div class="tournaments-table-win-line" v-else-if="winner?.prize?.type === 'prize'">
                        {{ winner?.prize?.prize }}
                      </div>
                      <div class="tournaments-table-win-line-fs" v-else-if="winner?.prize?.type === 'fs'">
                        {{ winner?.prize?.prize }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <router-link
                :to="{ name: 'tournament', params: { slug: tournamentsTypesLastActive.slug } }"
                class="gtournament-table-more"
              >
                Все
              </router-link>
            </div>
          </div>
        </div>
        <div v-if="this.tabActive === 1" class="tt-panel panel-fav">
          <a v-if="!this.favourites?.includes(game.slug)" @click="this.addToFavourite()" class="game-add-fav">
            <span>Добавить в избранное</span><i>{{ game.title }}</i>
          </a>
          <a v-else @click="this.removeFromFavourite()" class="game-add-fav game-remove-fav">
            <span>Удалить из избранного</span><i>{{ game.title }}</i>
          </a>

          <div class="fav-games-list">
            <div class="fav-game" v-for="favourite in favourites" :key="favourite">
              <router-link :to="{ name: 'game', params: { game: favourite } }" class="fav-game-image">
                <img :src="gameBySlug(favourite)?.icon" :alt="gameBySlug(favourite)?.title" />
              </router-link>

              <div class="fav-game-over">
                <router-link :to="{ name: 'game', params: { game: favourite } }" class="fav-game-sgio-link">
                  <span>{{ gameBySlug(favourite)?.title }}</span>
                </router-link>

                <a v-if="isAuthenticated" @click="this.removeFromFavourite()" class="fav-game-likes-done" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="this.tabActive === 2" class="tt-panel panel-win">
          <div class="game-wins-wrap">
            <div class="game-win-item" v-for="winner in winnersWeek" :key="winner.id">
              <div class="game-win-item-image">
                <img :src="gameBySlug(winner.gameSlug)?.icon" :alt="gameBySlug(winner.gameSlug)?.title" />
              </div>
              <div class="game-win-item-r">
                <div class="game-win-item-text">{{ winner.username }} выиграл</div>
                <div class="game-win-item-present" style="color: #eebd11">{{ n(winner.win) }}</div>
                <div class="game-win-item-title">{{ gameBySlug(winner.gameSlug)?.title }}</div>
                <router-link :to="{ name: 'game', params: { game: winner.gameSlug } }" class="game-win-item-play"
                  >Играть</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown'
import { mapGetters } from 'vuex'
import { ADD_TO_FAVOURITE, REMOVE_FROM_FAVOURITE } from '@/store/actions.type'
import { useI18n } from 'vue-i18n'
import { getTime } from 'date-fns'
import { transformSlotProps } from '@/utils'

export default {
  name: 'GameSidebar',
  components: { VueCountdown },
  data() {
    return {
      page: 'user',
      isCollapsed: false,
      tabActive: 1,
    }
  },
  setup() {
    const { t, n } = useI18n()

    return { t, n, getTime, transformSlotProps }
  },
  computed: {
    ...mapGetters(['game', 'winnersWeek', 'gameBySlug', 'tournamentsTypesLastActive', 'favourites', 'isAuthenticated']),
  },
  watch: {
    tournamentsTypesLastActive(newCount, oldCount) {
      if (!newCount) {
        this.tabActive = 1
      } else {
        this.tabActive = 0
      }
    },
  },
  mounted() {
    if (this.tournamentsTypesLastActive) {
      this.tabActive = 0
    }
  },
  methods: {
    addToFavourite() {
      this.$store.dispatch(ADD_TO_FAVOURITE, { slug: this.game.slug })
    },
    removeFromFavourite() {
      this.$store.dispatch(REMOVE_FROM_FAVOURITE, { slug: this.game.slug })
    },
  },
}
</script>

<style scoped>
.game-add-fav {
  cursor: pointer;
}
.gtournament-table tbody tr:nth-child(+ n + 6) {
  display: none;
}
.gametab {
  max-height: 100%;
  display: flex;
  flex-direction: column;
}
.index-panel {
  overflow: auto;
}
.gametab > .index-tabs {
  min-height: 112px;
}
</style>
